// src/components/PublicNavbar.js
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './PublicNavbar.css';

const PublicNavbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  // This function ensures the mobile menu closes when a link is clicked
  const closeMobileMenu = () => {
    setIsMenuOpen(false);
  };

  const logoUrl = 'https://firebasestorage.googleapis.com/v0/b/steps4inclusiveai.firebasestorage.app/o/site-assets%2Finclusive_logo.jpg?alt=media&token=7145cfae-02f9-43d1-b7cc-a5383c58be41';

  return (
    <nav className="public-navbar">
      <div className="navbar-container">
        <Link to="/" className="navbar-logo" onClick={closeMobileMenu}>
          {/* Replaced text with the logo image */}
          <img src={logoUrl} alt="Inclusive Ai Logo" className="logo-image" />
        </Link>

        {/* Hamburger/Close Icon */}
        <div className="menu-icon" onClick={toggleMenu}>
          {isMenuOpen ? (
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
          ) : (
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="3" y1="12" x2="21" y2="12"></line><line x1="3" y1="6" x2="21" y2="6"></line><line x1="3" y1="18" x2="21" y2="18"></line></svg>
          )}
        </div>

        {/* Unified Menu for both Desktop and Mobile */}
        <ul className={isMenuOpen ? 'nav-menu active' : 'nav-menu'}>
          <li className="nav-item">
            <Link to="/about" className="nav-links" onClick={closeMobileMenu}>
              About Us
            </Link>
          </li>
          {/* --- New Link Added Here --- */}
          <li className="nav-item">
            <Link to="/resources" className="nav-links" onClick={closeMobileMenu}>
              Resources
            </Link>
          </li>
          <li className="nav-item">
            <Link to="/contact" className="nav-links" onClick={closeMobileMenu}>
              Contact Us
            </Link>
          </li>
          <li className="nav-item-button">
            <Link to="/login" className="nav-links-button" onClick={closeMobileMenu}>
              Login
            </Link>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default PublicNavbar;